/*
 * This file defines typeface related mixins for use within styled-components
 * styling declarations.
 */

import { BREAKPOINTS } from '@ta-interaktiv/react-components'
import { css } from 'styled-components/macro'

export const fontCaption_ = css`
  font-family: var(--font-serif, var(--ui-font-stack));
  fontsize: 14px;
  lineheight: 20px;
  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    font-size: 18px;
  }
  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    font-size: 20px;
  }
`

/**
 * 33-49-60
 */
export const fontHeading1_ = css`
  font-family: var(--font-serif, var(--font-title));
  font-size: 33px;
  line-height: 1.15;

  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    font-size: 49px;
  }
  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    font-size: 60px;
  }
`

/**
 * 18-20-25
 */
export const fontLead_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-size: 18px;
  line-height: 1.45;

  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    font-size: 20px;
  }
  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    font-size: 25px;
  }
`

/**
 * 20-20-20
 */
export const fontHeading3_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 20px;
  line-height: 1.2;
`

export const fontByline_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
`

/**
 * 17-20-20 (w)
 */
export const fontHeading4_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 17px;
  line-height: 1.2;
  letter-spacing: 0.85px;

  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    font-size: 20px;
    letter-spacing: 1px;
  }
`

/**
 * 18-18-18
 */
export const fontLead4_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-size: 18px;
  line-height: 1.45;
`

/**
 * 17-17-18 (w)
 */
export const fontHeading5_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 17px;
  line-height: 1.2;
  letter-spacing: 0.85px;

  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    font-size: 18px;
    letter-spacing: 0.9px;
  }
`

/**
 * 12-14-16
 */
export const fontChartAxis_ = css`
  font-family: var(--ui-font-stack);
  font-size: 12px;

  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    font-size: 14px;
  }
  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    font-size: 16px;
  }
`

/**
 * 18 (regular)
 */
export const font18Regular_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 400;
  font-size: 18px;
`

/**
 * 18 (bold)
 */
export const font18Bold_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 18px;
`

/**
 * 16 (bold)
 */
export const font16Bold_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 16px;
  line-height: 1.375;
`

/**
 * 16 (regular)
 */
export const font16Regular_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 400;
  font-size: 16px;
  line-height: 1.375;
`

/**
 * 15 (bold)
 */
export const font15Bold_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 15px;
`

/**
 * 15 (regular)
 */
export const font15Regular_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 400;
  font-size: 15px;
`

/**
 * 14 (bold)
 */
export const font14Bold_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 700;
  font-size: 14px;
`

/**
 * 14 (bold)
 */
export const font14Regular_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 400;
  font-size: 14px;
`

/**
 * 12 (regular)
 */
export const font12Regular_ = css`
  font-family: var(--font-sans-serif, var(--ui-font-stack));
  font-weight: 400;
  font-size: 12px;
`
